var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['level', { 'level--has-tooltip': _vm.tooltip }]},[_c('span',{class:['level__color', `level__color--${_vm.level}`]}),_c('span',{staticClass:"level__text"},[_vm._t("default")],2),(_vm.tooltip != '')?_c('span',{staticClass:"level__tooltip"},[_c('p',[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }